<template>
  <div>
      <b-navbar toggleable="lg" type="dark" variant="info">
    <b-navbar-brand href="#">Agency</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="#/main">Dashboard</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template slot="button-content"><em>User</em></template>
          <b-dropdown-item href="javascript:void(1);" @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
      <div class="container-fluid">
      
        <div>
            <slot></slot>
        </div>
    </div>
  
  </div>
</template>
<script>
import service from '@/services/service.js'
export default {
  name: 'Container',
  created(){
      let profile = service.getobject('me');
      console.log('the profile:', service.getCurrentToken());
      if (profile === null){
          this.$router.push('/');
      }
  },
  data () {
    return {
    }
  },
  methods:{
      logout(){
          service.clearobject('me');
          this.$router.push('/');
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Container.vue